export default "__VITE_ASSET__CerELSU8__"